import React, { useState, useContext, useEffect, useRef } from "react"
import { AppContext } from "./Context"

import styles from "./main.module.scss"
import headerStyles from "./header.module.scss"

const Main = ({ children, location, footerEl }) => {

  const appState = useContext(AppContext)

  const mainEl = useRef(null)

  const [headerScrollOut, setHeaderScrollOut] = useState(false)

  // Handle header scroll out when reaching last homepage module
  useEffect(() => {
    if (typeof window !== "undefined")
      document.addEventListener("scroll", handleScroll)
    return () =>
      document.removeEventListener("scroll", handleScroll)
  })

  const handleScroll = e => {
    if (location.pathname === "/") {
      const scrollTop = window.scrollY
      const modules = mainEl.current.getElementsByTagName("section")
      const lastModule = modules[modules.length - 1]
      const lastModuleOffsetTop = lastModule.offsetTop

      // if (scrollTop + windowHeight > mainHeight) {
      if (scrollTop > lastModuleOffsetTop) {
        setHeaderScrollOut(true)
      } else {
        setHeaderScrollOut(false)
      }
    }
  }

  // Add bottom padding to account for height of homepage footer
  useEffect(() => {
    if (footerEl && typeof window !== "undefined" && window.outerWidth >= 1024) {
      if (location.pathname === "/") {
        const footerHt = footerEl.current.offsetHeight
        mainEl.current.style.paddingBottom = `${footerHt}px`
      } else {
        mainEl.current.style.paddingBottom = `0px`
      }
    }
  }, [location, footerEl])

  return(
    <main
      className={`
        ${(location.pathname !== "/") ? styles.mainContainer : headerStyles.homepageContainer}
        ${(appState.navOpen) ? headerStyles.navOpen : ""}
        ${(headerScrollOut) ? headerStyles.headerScrollOut : ""}
      `}
      ref={mainEl}
    >
      {children}
    </main>
  )
}

export default Main
